module.exports = __webpack_public_path__ + "static/media/Slack_Technologies_Logo.e4e46be2.svg";